
<template>
  <div>
    <v-dialog v-model="dialog" scrollable persistent max-width="900px" transition="dialog-transition">
      <v-card style="border-radius:12px">
        <v-card-title primary-title class="py-3">
          <div class="headline mb-0">Detalhes de {{ kind_map[kind]}}</div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-5">
          <v-alert v-if="loading" type="info" :value="true">
            Carregando dados
            <v-progress-linear color='white' :indeterminate="true"></v-progress-linear>
          </v-alert>
          <div v-if="!loading">
            <component :is="kind_info_map[[kind]]" :info="data_element" v-if="data_element.id && kind != 'bill'">
            </component>
            <bill-profile v-if="kind == 'bill'" :id="element_id"></bill-profile>
          </div>

        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <v-btn text color="primary" @click="dialog = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from '@/api/index'
import { mapMutations } from 'vuex'
import BillProfile from '@/_backoffice/_financial/components/bill/shared/BillProfile.vue'

export default {
  name: 'DialogItemDetails',
  components: {
    BillProfile,
    InfoCash: () => import('@/_backoffice/_registrations/components/client/pay_traces/item_info/InfoCash.vue'),
    InfoCheck: () => import('@/_backoffice/_registrations/components/client/pay_traces/item_info/InfoCheck.vue'),
    InfoDeposit: () => import('@/_backoffice/_registrations/components/client/pay_traces/item_info/InfoDeposit.vue'),
    InfoPix: () => import('@/_backoffice/_registrations/components/client/pay_traces/item_info/InfoPix.vue'),
    InfoVrtTrans: () => import('@/_backoffice/_registrations/components/client/pay_traces/item_info/InfoVrtTrans.vue'),
  },
  props: {
    element_id: {
      type: [Number, String],
    },
    kind: {
      type: String
    }
  },
  data() {
    return {
      dialog: true,

      data_element: {},
      loading: false,

      kind_map: {
        check: "Cheque",
        bill: "Boleto",
        pix: "PIX",
      },
      kind_info_map: {
        vrt_transaction: "InfoVrtTrans",
        deposit: "InfoDeposit",
        check: "InfoCheck",
        cash: "InfoCash",
        bill: "InfoBill",
        pix: "InfoPix",
      },
      element_type_map: {
        vrt_transaction: {
          module: "VrtTransaction",
          action: 'show'
        },
        deposit: {
          module: "Deposit",
          action: 'show'
        },
        check: {
          module: "Check",
          action: 'show'
        },
        cash: {
          module: "Cash",
          action: 'show'
        },
        bill: {
          module: "Bill",
          action: 'show'
        },
        pix: {
          module: "Pix",
          action: 'show'
        },
      },
    }
  },
  methods: {
    getElement() {
      const { module, action } = this.element_type_map[this.kind]
      this.loading = true
      Api[module][action](this.element_id).then(r => r.data).then(d => {
        // console.log({d});
        d = d.data ? d.data.attributes : d
        this.data_element = { ...d }
        setTimeout(() => {
          this.loading = false
        }, 800);
      })
    },
    showBillDetails() {
      this.loading = true
      Api.Bill.show(this.element_id).then(r => r.data).then(d => {
        this.setOneBill({ item: d, kind: 'bills' });
      }).finally(()=>{
        this.loading = false
      })

    },
    ...mapMutations({
      setOneBill: 'Financial/getOneFinancial'
      // function: 'Module/action'
    })
  },
  mounted() {
    if (this.kind == 'bill') {
      this.showBillDetails();
    } else {
      this.getElement();
    }
  },
  watch: {
    dialog(nv, ov) {
      if (nv) {
      } else if (nv == false) {
        if (this.kind == 'bill') {
          this.setOneBill({ item: null, kind: 'bills' });
        }
        this.$emit('close')
      }
    }
  },
}
</script>